import axios from "axios";

const metricaEstabelecimentoApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND}/metrica-estabelecimento`
})

async function servGetMetricaByEstabelecimento(estabelecimentoId, trazerMetrica14, apenasMetricasInerentes) {
    const response = await metricaEstabelecimentoApi.get('/por-estabelecimento',
        { params: { estabelecimentoId, trazerMetrica14, apenasMetricasInerentes} }
    )
    return response
}

export {
    servGetMetricaByEstabelecimento
}